let pathSh = meta.page.pageType;
var printOnlySelect = false
if (pathSh == 'product') {
    if (document.getElementsByTagName('livearf-variant-selects')[0]) {
        loadjscssfile("https://shop.livearf.com/lb4b-shop/dist/css/livevue-template.min.css", "css");
        // loadjscssfile("https://lb4b-shop.in.ngrok.io/styles/livevue-template.css", "css")
        if (livevue_translate_data && livevue_translate_data.length > 0) {
            for (let i = 0; i < livevue_translate_data.length; i++) {
                if (document.querySelector('[data-trans-key="' + livevue_translate_data[i].key + '"]')) {
                    if (livevue_translate_data[i][Shopify.locale]) {
                        document.querySelector('[data-trans-key="' + livevue_translate_data[i].key + '"]').innerText = livevue_translate_data[i][Shopify.locale];
                    }
                }
            }
        }
		console.log("yes its running in dev store")
        const previewIcons = livevue_settings?.settings?.previewIcons?.settings;     
        function applyPreviewIconStyles() {
            const previewIconsDiv = document.getElementById('previewIcons');
            if (previewIconsDiv) {
                previewIconsDiv.removeAttribute('style');
                const updateStyles = () => {
                    const isDesktop = window.innerWidth >= 768;
                    const currentVp = isDesktop ? previewIcons?.vertical_position?.desktop : previewIcons?.vertical_position?.mobile;
                    const currentHp = isDesktop ? previewIcons?.horizontal_position?.desktop : previewIcons?.horizontal_position?.mobile;
                    const currentAlign = isDesktop ? previewIcons?.icon_alignment?.desktop : previewIcons?.icon_alignment?.mobile;
                    previewIconsDiv.classList.remove('top-left', 'top-center', 'top-right','middle-left', 'middle-center', 'middle-right','bottom-left', 'bottom-center', 'bottom-right');
                    // if (currentVp && currentHp) {
                    //     previewIconsDiv.classList.add(`${currentVp}-${currentHp}`);
                    // }
                    const previewIconsUl = previewIconsDiv.querySelector('ul');
                    if (previewIconsUl) {
                        previewIconsUl.removeAttribute('style');
                        previewIconsUl.classList.remove('align-horizontal', 'align-vertical');
                        if (currentAlign) {
                            previewIconsUl.classList.add(`align-${currentAlign}`);
                        }
                    }
                };
                updateStyles();
                window.removeEventListener('resize', updateStyles);
                window.addEventListener('resize', updateStyles);
            }
        }
        applyPreviewIconStyles()
        if (larf_flow) {
            const pricingData = [];
            const allOptions = Array.isArray(linked_components)
                ? linked_components.flatMap(c =>
                    Array.isArray(c?.options) ? c.options : []
                )
                : [];
            if (allOptions.length) {
                pricingData.push(
                    ...allOptions.flatMap(opt =>
                        (Array.isArray(opt?.option_values) ? opt.option_values : []).map(v => ({
                            option_value_id: v.id,
                            overall_size: opt.pricing_classification_basis === "overall-size", 
                            include_in_frame_size: v.include_in_frame_size || false,
                            pricing_v2: Array.isArray(v.pricing_v2)
                                ? v.pricing_v2
                                : []
                        }))
                    )
                );
            }
            let variantId;
            let larfPrice;
            let dataObject = [];
            let livevueImgUpload = false;
            let orderImage;
            var applyPeel = false
            let variantRemoved = false;
            let priceElement = document.createElement('span');
            priceElement.className = "livevue-display-price";
            priceElement.innerHTML = document.querySelector('#larf-display-price').innerText;
            let discountElement = document.createElement('span');
            discountElement.className = "livevue-discount-price";
            discountElement.style.display = 'none';
            discountElement.style.marginLeft = "1rem";
            discountElement.innerHTML = document.querySelector('#larf-display-price').innerText;
            let salebanner = document.createElement('span');
            salebanner.className = "livevue-sale-banner badge price__badge-sale color-scheme-4";
            salebanner.innerHTML = "Sale";
            salebanner.style.marginLeft = "1rem";
            salebanner.style.display = "none";
            let placeElement = document.querySelector('#larf-display-price');
            placeElement.after(salebanner);
            placeElement.after(discountElement);
            placeElement.after(priceElement);
            placeElement.style.display = 'none';
            const cartMessages = livevue_settings?.settings?.addtoCart?.texts || [{"value":"Adding to Cart"}];
            let cartPageLoader = document.createElement('div');
            cartPageLoader.id = 'larfloader';
            cartPageLoader.innerHTML = `<div class="loader-spinner"><p></p></div><div class="loader-text">${cartMessages[0]?.value}</div>`;
            const loaderText = cartPageLoader.querySelector(".loader-text");
            document.querySelector('body').append(cartPageLoader);
            var selectedType = "";
            let selectedFrameStyle = "";
            let selectedMatsize = "";
            let selectedMatcolor = "";
            let allProperties;
            if (document.getElementsByClassName('uploadYourImage')[0]) {
                livevueImgUpload = true;
            }
            setTimeout(() => {
                const priceEl = document.querySelector('.livevue-display-price');
                if (!priceEl) return;
                if (/0\.00/.test(priceEl.innerText)) {
                    if (!sessionStorage.getItem('zeroPriceReloaded')) {
                        sessionStorage.setItem('zeroPriceReloaded', 'true');
                        location.reload();
                    }
                } else {
                    sessionStorage.removeItem('zeroPriceReloaded');
                }
            }, 200);
            var offsetwidth = document.getElementsByClassName('mainFrameDiv')[0].offsetWidth;
            var enlarge = document.createElement('div')
            enlarge.id = 'enlarge'
            document.body.appendChild(enlarge);
            var enlargeIcon = document.createElement('img');
            enlargeIcon.id = 'enlargeIcon';
            enlargeIcon.src = 'https://cdn.shopify.com/s/files/1/0773/6655/9038/files/enlarge1.webp';
            enlargeIcon.style.cssText = `padding: 10px;border-radius: 10px;background-color: rgba(0, 0, 0, 0.49); color: rgb(255, 255, 255);top: 0.5rem;text-align: center; z-index: 1; width: 3rem; position: absolute;left: 94%;height:3rem;`;
            var roomImage = document.getElementById('roomImage');
            roomImage.insertAdjacentElement('afterend', enlargeIcon);
            var roomSliderPrev = document.createElement('button');
            roomSliderPrev.className = 'larfhispic_slider-button larfhispic_slider-button-prev';
            roomSliderPrev.innerText = '←';
            roomImage.after(roomSliderPrev);
            var roomSliderNext = document.createElement('button');
            roomSliderNext.className = 'larfhispic_slider-button larfhispic_slider-button-next';
            roomSliderNext.innerText = '→';
            roomImage.after(roomSliderNext);
            var icons = document.querySelectorAll('#room-icons-set li');
            let currentIndex = 0;
            // currentSize.lineSize = 40;
            // Helper: trigger click on current index
            function triggerClick(index) {
                if (icons[index]) {
                    icons[index].click(); // simulate click
                }
                // currentSize.lineSize = 40;
                console.log('lineSize set to:', currentSize.lineSize);
            }
            document.querySelector('.larfhispic_slider-button-next').addEventListener('click', function () {
                currentIndex = (currentIndex + 1) % icons.length; // wrap around
                triggerClick(currentIndex);
            });
            document.querySelector('.larfhispic_slider-button-prev').addEventListener('click', function () {
                currentIndex = (currentIndex - 1 + icons.length) % icons.length; // wrap around
                triggerClick(currentIndex);
            });
            // Optional: Update index if user clicks manually
            icons.forEach((li, index) => {
                li.addEventListener('click', () => {
                    currentIndex = index;
                    setTimeout(() => {
                        // currentSize.lineSize = 40;
                        console.log('lineSize set to:', currentSize.lineSize);
                    }, 1000)
                });
            });

            if (window.matchMedia("(max-width: 600px)").matches) {
                console.log("mobile view");
                // document.querySelector('.changeBackgroundDiv').parentElement.style.gridColumn='1'
                console.log("all image div", document.querySelector('li#galleryView-preview div#allImage'))
                console.log("all image ul", document.querySelector('li#galleryView-preview div#allImage ul'))
                document.querySelector('#enlargeIcon').style.left = '90%';
                document.querySelector('.product__media-list li').style.setProperty('max-width', '100%', 'important');
                var mainRoomParentClass = document.getElementById('roomView-preview').querySelector('.product-media-container');
                mainRoomParentClass.style.height = '500px';
                mainRoomParentClass.style.marginBottom = '0px';
                var roomIconSetParentDiv = document.getElementsByClassName('roomsCollections')[0].parentElement.parentElement;
                roomIconSetParentDiv.style.bottom = '0px !important';
                setTimeout(() => {
                    if (currentSize.height > currentSize.width) {
                        currentSize.orientation = 'portrait'
                    } else {
                        currentSize.orientation = 'landscape'
                    }
                    document.querySelector('li#galleryView-preview div#allImage').classList.remove('bottom-center');
                    document.querySelector('li#galleryView-preview div#allImage ul').classList.remove('align-horizontal');
                }, 1000)
            } else {
                setTimeout(() => {
                    document.querySelector('li#galleryView-preview div#allImage').classList.remove('top-left');
                    document.querySelector('li#galleryView-preview div#allImage ul').classList.remove('align-horizontal');
                }, 1000)
                setTimeout(() => {
                    // document.querySelector('.changeBackgroundDiv').parentElement.style.gridColumn='1';
                    var mainRoomParentClass = document.getElementById('roomView-preview').querySelector('.product-media-container');
                    mainRoomParentClass.style.height = '500px';
                    mainRoomParentClass.style.marginBottom = '20%';
                    var roomIconSetParentDiv = document.getElementsByClassName('roomsCollections')[0].parentElement.parentElement;
                    roomIconSetParentDiv.style.bottom = '0px !important';
                    document.querySelector('.social-sharing').style.marginLeft = '1.5em';
                }, 3000)
            }

            const threeDView = document.querySelector('#threeDView');
            const frameView = document.querySelector('#frameView');
            const normalizeSize = (str = '') => {// Normalize size: "12 x 18" === "18 x 12"
                const nums = str.match(/\d+/g)?.map(Number);
                return nums?.length === 2 ? nums.sort((a, b) => a - b).join(' x ') : '';
            };

            const isInRange = (range, value) => {
              const [min, max] = range.split("-").map(Number);
              return value >= min && value <= max;
            };
            
            const getEffectiveSize = (overallSize = false) => {
                const width = Number(currentSize.width);
                const height = Number(currentSize.height);

                if (!overallSize) {
                    return { width, height };
                }
            
                const frame = Number(currentSize.frameThickness || 0);
                const firstMat = Number(currentSize.firstMatSize || 0);
                const secondMat = Number(currentSize.secondMatSize || 0);
                const extra = 2 * (frame + firstMat + secondMat);
                return {
                    width: width + extra,
                    height: height + extra,
                };
            };

            const getPredefinedPrice = (predefinedPrice = [], rule = {},overallSize = false) => {
                const priceType = rule.price_type || '';
                if (!Array.isArray(predefinedPrice)) {
                    return {
                        price: 0,
                        calculation_type: 'fixed-price'
                    };
                }
                let price = 0;
                let calculation_type = 'fixed-price';
                let match = null;
                if (priceType.startsWith('predefined-')) {
                    const inputSize = normalizeSize(`${currentSize.width} x ${currentSize.height}`);
                    const match = predefinedPrice.find(item => normalizeSize(item.value) === inputSize);
                    price = Number(match?.price || 0);
                    calculation_type = priceType.replace('predefined-', '');
                } else if (priceType.includes('range')) {
                    const { width, height} = getEffectiveSize(overallSize);
                    let compareValue = 0;

                    if (rule.calculation_type?.includes('surface')) {
                        compareValue = width * height;
                    } else if (rule.calculation_type === 'perimeter') {
                        compareValue = 2 * (width + height);
                    } else if (rule.calculation_type === 'linear_max' || priceType === 'range-size_fixed-price') {
                        compareValue = Math.max(width, height);
                    } else {
                        compareValue = width + height; 
                    }
                    match = predefinedPrice.find(item =>
                        isInRange(item.value || item.range, compareValue)
                    );
                    price = Number(match?.price || 0);
                    if (priceType.includes('ranged')) {
                        calculation_type = 'fixed-price';
                    } else if(priceType === 'range-size_fixed-price'){
                        calculation_type = 'linear_max';
                    } else if (priceType === 'range-size_unit-price') {
                        calculation_type = rule.calculation_type;
                    }
                }
                return { price, calculation_type, range: match?.range || '' };
            };

            // function applyImageToCanvas(applyPeel = false) {
            //     console.log("Rendering image. Peel effect:", applyPeel);
            //     const canvas = document.getElementById('frameViewCanvas');
            //     const ctx = canvas.getContext("2d");
            //     const artwork = new Image();
            //     artwork.crossOrigin = "anonymous";
            //     artwork.src = mainImage.src;
            //     artwork.onload = () => {
            //         const containerWidth = canvas.parentElement.offsetWidth;
            //         const scaleFactor = containerWidth / artwork.width;
            //         const w = artwork.width * scaleFactor;
            //         const h = artwork.height * scaleFactor;
            //         canvas.width = w;
            //         canvas.height = h;
            //         ctx.clearRect(0, 0, w, h);
            //         ctx.drawImage(artwork, 0, 0, w, h);
            //         if (applyPeel) {
            //             const peel = new Image();
            //             peel.crossOrigin = "anonymous";
            //             peel.src = "https://cdn.shopify.com/s/files/1/0059/5404/3974/files/peel-sticker.png?v=1745567704";
            //             peel.onload = () => {
            //                 var peelScale;
            //                 if (window.matchMedia("(max-width: 600px)").matches) {
            //                     peelScale = 0.1;
            //                 } else {
            //                     peelScale = 0.2;
            //                 }
            //                 const peelW = peel.width * peelScale;
            //                 const peelH = peel.height * peelScale;
            //                 ctx.drawImage(peel, 0, h - peelH, peelW, peelH);
            //             };
            //         }
            //     };
            // }
            function applyImageToCanvas(applyPeel = false) {
                const canvas = document.getElementById('frameViewCanvas');

                if (!canvas) return;

                // Remove previous peel sticker
                document.getElementById('peelOverlay')?.remove();

                // Only add peel effect for Peel & Stick
                if (!applyPeel) return;

                const wrapper = canvas.parentElement;

                if (!wrapper) return;

                const peel = document.createElement('img');

                peel.id = 'peelOverlay';
                peel.src = 'https://cdn.shopify.com/s/files/1/0059/5404/3974/files/peel-sticker.png?v=1745567704';

                peel.style.position = 'absolute';
                peel.style.left = '0';
                peel.style.bottom = '0';
                peel.style.pointerEvents = 'none';
                peel.style.zIndex = '10';

                if (window.matchMedia('(max-width: 600px)').matches) {
                    peel.style.width = '20%';
                } else {
                    peel.style.width = '20%';
                }

                // Make sure overlay is positioned relative to the canvas
                if (getComputedStyle(wrapper).position === 'static') {
                    wrapper.style.position = 'relative';
                }

                wrapper.appendChild(peel);
            }
            function generateSku() {
                let skuSize = currentSize.selectedValue;
                let prefixSku;
                const variantInput = document.querySelector('.product-variant-id');
                let skuFromBarcode;
                if (variantInput) {
                    let valueFromSku = product_variants.find(item => item.id == variantInput.value)?.sku
                    if (valueFromSku) {
                        valueFromSku = valueFromSku.replace(/_P\d+$/, '');
                    }
                    let valueFromBarcode = product_variants.find(item => item.id == variantInput.value)?.barcode;
                    if (valueFromBarcode && valueFromBarcode.split('_').length > 1) {
                        skuFromBarcode = valueFromBarcode;
                    }
                    prefixSku = valueFromSku || skuFromBarcode
                }
                let frameSku, matSku
                var skuData = ''
                if (selectedType && selectedType.toLowerCase() == 'framed') {
                    skuData = 'F'
                } else if (selectedType && selectedType.toLowerCase() == 'print only') {
                    skuData = 'P'
                } else if (selectedType && selectedType.toLowerCase() == 'infinity frame') {
                    skuData = 'S'
                } else if (selectedType && selectedType.toLowerCase() == 'canvas') {
                    skuData = 'C'
                } else if (selectedType && selectedType.toLowerCase() == 'peel and stick') {
                    skuData = 'V'
                } else if (selectedType && selectedType.toLowerCase() == 'wood mount') {
                    skuData = 'W'
                }
                skuData += skuSize.replace(/in|\s|x/gi, '');
                if (selectedType && selectedType.toLowerCase() == 'infinity frame') {
                    skuData += 'AAA'
                } else if (selectedType && selectedType.toLowerCase() == 'framed') {
                    if (selectedMatsize && selectedMatsize.replace(/\s+/g, "").toLowerCase() == '2.0in') {
                        matSku = 'B'
                    } else if (selectedMatsize && selectedMatsize.replace(/\s+/g, "").toLowerCase() == '3.0in') {
                        matSku = 'C'
                    } else if (selectedMatsize && selectedMatsize.toLowerCase() == 'no mat') {
                        matSku = 'A'
                    }
                    if (selectedFrameStyle && selectedFrameStyle.toLowerCase() == 'black frame') {
                        frameSku = 'AA'
                    } else if (selectedFrameStyle && selectedFrameStyle.toLowerCase() == 'white frame') {
                        frameSku = 'AB'
                    } else if (selectedFrameStyle && selectedFrameStyle.toLowerCase() == 'brown frame') {
                        frameSku = 'AC'
                    }
                    skuData += frameSku + matSku
                }
                var finalSku
                if (prefixSku) {
                    finalSku = prefixSku + '_' + skuData
                } else {
                    finalSku = skuData
                }
                return finalSku
            }

            // var typeField = document.querySelector('fieldSet[name="TYPE"]')
            // if(typeField){
            //     typeField.addEventListener('change', function(){
            //         document.getElementById('frameView').click()
            //     })
            // }

            function skuDisplay() {
                const variantInput = document.querySelector('.product-variant-id');
                let skuValue;
                let skuFromBarcode;
                if (variantInput) {
                    let valueFromSku = product_variants.find(item => item.id == variantInput.value)?.sku;
                    let valueFromBarcode = product_variants.find(item => item.id == variantInput.value)?.barcode;
                    if (valueFromBarcode && valueFromBarcode.split('_').length > 1) {
                        skuFromBarcode = valueFromBarcode;
                    }
                    skuValue = valueFromSku || skuFromBarcode
                }
                const productInfo = document.querySelector('product-info');
                const productDescription = document.querySelector('.product__description.rte.quick-add-hidden');
                if (productInfo && skuValue) {
                    const existingSku = productInfo.querySelector('.variant-sku');
                    if (existingSku) {
                        existingSku.textContent = skuValue;
                    } else {
                        const headingBlock = document.createElement('div');
                        headingBlock.className = 'product-block';
                        headingBlock.style.cssText = `max-width:1000px; margin:0 auto;`;
                        const infoBlock = document.createElement('div');
                        infoBlock.className = 'info-block';
                        infoBlock.innerHTML = `<h4 class="more_info" style="margin-bottom: 0;"><span style="background: #8f191c; color: #fff; padding: 9px 15px; display: inline-block; font-size: 16px; font-weight: 400; margin-left: 3%;">More Information</span> </h4>`;
                        const wrapperDiv = document.createElement('div');
                        wrapperDiv.className = 'product-details-wrapper';
                        wrapperDiv.style.cssText = `outline: medium none; padding: 20px 20px 50px; text-align: left; border: 1px solid #eff2f4; margin-left: 3%;`;
                        const skuDiv = document.createElement('div');
                        skuDiv.className = 'sku-box';
                        const bold = document.createElement('b');
                        bold.textContent = 'Sku:';
                        const span = document.createElement('span');
                        span.className = 'variant-sku';
                        span.textContent = skuValue;
                        skuDiv.appendChild(bold);
                        skuDiv.append(' ');
                        skuDiv.appendChild(span);
                        wrapperDiv.appendChild(productDescription);
                        wrapperDiv.appendChild(skuDiv);
                        headingBlock.appendChild(infoBlock);
                        headingBlock.appendChild(wrapperDiv);
                        productInfo.appendChild(headingBlock);
                    }
                } else {
                    console.warn('<product-info> element not found or SKU is missing.');
                }
                pricingCalculation(dataObject)
            }
            // addTocart fn for mobile view only
            function addToCart() {
                if (!window.matchMedia("(max-width: 600px)").matches) return;
                document.querySelector('.fixedLayer')?.remove();
                document.getElementById('newPreviewArea')?.remove();
                const size = document.querySelector('input[name="Size-1"]:checked')?.value || '';
                document.querySelector('.product-form__submit')?.style.setProperty('display', 'none');

                document.body.insertAdjacentHTML('beforeend', `<div class="fixedLayer" style="display:flex;align-items:center;justify-content:space-between;max-height:70px;height:70px;z-index:3;position:fixed;bottom:0;left:0;width:100%;background:#fff;padding:0 0 0 15px;border-top:1px solid #8f191c;"><div class="miniPicSide" style="flex:1;align-items:center;"></div><div class="pricingSide" style="flex:1.5;align-items:center;display:flex;flex-direction:column;"></div><div class="cartbtnSide" style="flex:3;align-items:center;"><button id="duplicateAddtoCart" style="background:#8f191c!important;color:#fff!important;padding:22px 0;width:100%;font-weight:700;">Add To Cart</button></div></div>`);

                const miniContainer = document.querySelector('.miniPicSide'),
                originalDiv = document.querySelector('.main-previewArea'),
                mainImageCanvas = document.querySelector('#frameViewCanvas');
                if (originalDiv && miniContainer && mainImageCanvas) {
                    const clonedDiv = originalDiv.cloneNode(true),
                        newMainFrameDiv = clonedDiv.querySelector('.mainFrameDiv'),
                        newMainImageDiv = clonedDiv.querySelector('.mainimageDiv');

                    clonedDiv.id = 'newPreviewArea';
                    clonedDiv.classList.add('new' + clonedDiv.classList[1]);
                    clonedDiv.classList.add('miniLivearfProduct');
                    clonedDiv.style.width = '75%';
                    clonedDiv.style.height = 'auto';
                    clonedDiv.querySelector('#sideShow').id = 'new_sideshow_id';
                    if (newMainFrameDiv) {
                        let roomImageMatSize;
                        let frameBorder;
                        // if (selectedType === "Canvas") {
                        //     newMainFrameDiv.classList.remove('mirrorWrap');
                        //     setTimeout(() => {
                        //         document.querySelector('#new_sideshow_id').classList.remove('frameSide');
                        //     }, 100);
                        //     roomImageMatSize = 0;
                        // } else 
                        if (selectedType === "Infinity Frame") {
                            newMainFrameDiv.classList.remove('hispicThreeDeffect');
                            frameViewCanvas.classList.toggle('infinityFrameBorder', hispicThreeD);
                            roomImageMatSize = 0;
                            frameBorder = 0;
                        } else if (selectedType === "Framed") {
                            newMainFrameDiv.classList.remove('hispicThreeDeffect');
                            // frameViewCanvas.classList.toggle('infinityFrameBorder', hispicThreeD);
                            newMainFrameDiv.classList.remove('mirrorWrap');
                            // sideWrapSh.classList.remove('frameSide');
                            // sideWrapSh.style.backgroundImage = "";
                            roomImageMatSize = (currentSize.firstMatSize == 0) ? 0 : (currentSize.firstMatSize == 3) ? 5 : 3;
                            frameBorder = 2;
                        } else{
                            roomImageMatSize = 0;
                            frameBorder = 0; 
                        }
                        const inlineStyles = {};
                        for (let i = 0; i < newMainFrameDiv.style.length; i++) {
                            const key = newMainFrameDiv.style[i];
                            inlineStyles[key] = newMainFrameDiv.style.getPropertyValue(key);
                        }
                        inlineStyles.borderWidth = frameBorder + 'px';
                        inlineStyles.padding = roomImageMatSize + 'px';
                        inlineStyles.boxShadow = 'none';
                        newMainFrameDiv.removeAttribute('style');
                        newMainFrameDiv.classList.remove('mainFrameDiv');
                        newMainFrameDiv.classList.add('new' + newMainFrameDiv.classList[0]);
                        newMainFrameDiv._transferredStyles = inlineStyles;
                    }
                    if (newMainImageDiv) {
                        newMainImageDiv.classList.add('new' + newMainImageDiv.classList[0]);
                        newMainImageDiv.innerHTML = '';
                        const img = new Image();
                        Object.assign(img, {
                            className: "newimage-magnify-lightbox",
                            src: document.querySelector('#roomInnerDiv img').src
                        });
                        const baseStyles = { width: 'auto', height: 'auto', display: 'block', margin: '0 auto', maxWidth: '50px' };
                        Object.assign(img.style, { ...baseStyles, ...(newMainFrameDiv._transferredStyles || {}) });
                        // setTimeout(() =>{
                        if (currentSize.orientation === 'portrait') {
                            newMainImageDiv.style.height = '50px';
                        }
                        // },500)
                        newMainImageDiv.appendChild(img);
                    }
                    miniContainer.appendChild(clonedDiv);
                }
                const originalPrice = document.querySelector('.livevue-display-price'),
                    pricingSide = document.querySelector('.pricingSide');
                if (originalPrice && pricingSide) {
                    originalPrice.style.display = 'none';
                    const priceClone = originalPrice.cloneNode(true);
                    Object.assign(priceClone.style, { display: 'block', marginBottom: '2px', fontWeight: '500', fontSize: '16px' });
                    const priceText = originalPrice.textContent.trim().split(' ')[0];
                    priceClone.textContent = priceText;
                    pricingSide.appendChild(priceClone);
                    pricingSide.insertAdjacentHTML('beforeend', `<span id="sizeShowInBottom" style="font-size:12px;font-weight:700;display:block;">${size}</span>`);
                }
                document.getElementById('duplicateAddtoCart')?.addEventListener('click', () =>
                    document.querySelector('button[name="add"]')?.click()
                );
                const drawer = document.getElementById('CartDrawer');
                if (drawer) {
                    new MutationObserver(() => {
                        const fixed = document.querySelector('.fixedLayer');
                        if (fixed) fixed.style.zIndex = drawer.classList.contains('drawer--is-open') ? '-1' : '3';
                    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
                }
                document.querySelectorAll('.product-form__input').forEach(el => {
                    el.addEventListener('change', e => {
                        if (e.target.getAttribute('option_name') === 'Type') window.scrollTo(0, 0);
                    });
                });
            }
            
            if (window.matchMedia("(max-width: 600px)").matches) {
                console.log("here is the f")

                const f = document.createElement("div");
                f.className = "framingLinks";
                f.innerHTML = `<a href="https://www.historicpictoric.com/pages/framing-options" target="_blank"> About Framing </a>`;
                const matStyleFieldset = [...document.querySelectorAll("fieldset")].find(fs =>
                    fs.querySelector('input[action="1st-mat-style"]')
                );
                console.log("here is the f", f)
                if (matStyleFieldset) {
                    matStyleFieldset.after(f);
                }
            }
            //Tooltip
            const tooltip = document.createElement("div");
            tooltip.className = "type_tooltip";
            tooltip.innerText = '.';
            document.body.appendChild(tooltip);
            console.log("here is the tooltip", tooltip)
            let activeLabel = null;
            let canTap = true;
            let scrollTimeout;
            function showTooltipAtLabel(label, text) {
                const rect = label.getBoundingClientRect();
                const top = Math.max(0, rect.top - 10);
                const left = Math.min(window.innerWidth, rect.left + rect.width / 2);

                tooltip.innerText = text;
                tooltip.style.left = `${left}px`;
                tooltip.style.top = `${top}px`;
                tooltip.style.display = "block";
                tooltip.style.visibility = "visible";
                tooltip.style.opacity = "1";
            }
            function hideTooltip() {
                tooltip.style.visibility = "hidden";
                tooltip.style.opacity = "0";
                tooltip.style.display = "none";
                activeLabel = null;
            }
            function lockTapAfterScroll() {
                canTap = false;
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(() => {
                    canTap = true;
                }, 100);
            }
            document.querySelectorAll("fieldset").forEach(fieldset => {
                fieldset.querySelectorAll("input[type='radio'], input[type='checkbox']").forEach(input => {
                    const tooltipText = input.getAttribute("data-tooltip");
                    if (!tooltipText) return;

                    const label = fieldset.querySelector(`label[for="${input.id}"]`);
                    if (!label) return;

                    label.addEventListener("touchend", (e) => {
                        if (!canTap) return;
                        //   e.preventDefault();
                        if (activeLabel === label) return;
                        activeLabel = label;
                        showTooltipAtLabel(label, tooltipText);
                    });

                    label.addEventListener("click", () => {
                        if (activeLabel === label) return;
                        activeLabel = label;

                        showTooltipAtLabel(label, tooltipText);

                    });

                    label.addEventListener("mouseenter", () => {
                        if (window.innerWidth <= 900) return;
                        showTooltipAtLabel(label, tooltipText);
                    });

                    label.addEventListener("mouseleave", () => {
                        if (window.innerWidth <= 900) return;
                        hideTooltip();
                    });
                });
            });
            window.addEventListener("scroll", () => {
                hideTooltip();
                lockTapAfterScroll();
            }, true);

            document.querySelectorAll("all-variant").forEach(container => {
                container.addEventListener("scroll", () => {
                    hideTooltip();
                    lockTapAfterScroll();
                }, true);
            });
            var createFrameSummary = document.createElement('div')
            createFrameSummary.innerHTML = `<div class="lb4b-summary" style="margin-bottom:2em;margin-top: 15px;"><ul style="margin-bottom:2em;margin-left:0; list-style:none;line-height:16px;" class="larf-frame-summary"></ul></div>`;
            var customContent = document.querySelector('.social-block-content');
            document.querySelector('.product-form__buttons').after(createFrameSummary)
            if (window.matchMedia("(min-width: 320px) and (max-width: 750px)").matches) {
                document.querySelector('.lb4b-summary').style.marginBottom = '1em';
                document.querySelector('.lb4b-summary ul').style.marginBottom = '3px';
            }
            if(customContent){
                document.querySelector('.lb4b-summary').after(customContent)
            }
            
            function hispicFrameSummary() {
                var framed_image_width;
                var framed_image_height;
                let isFramed = false;
                let isMatSelected = false;
                let matSummary;
                isFramed = selectedType === 'Framed';
                isMatSelected = selectedMatsize !== 'No Mat' && selectedMatsize !== '';
                if (isMatSelected && !isFramed) {
                    framed_image_width = Number(currentSize.width) + 2 * Number(currentSize.firstMatSize);
                    framed_image_height = Number(currentSize.height) + (2 * Number(currentSize.firstMatSize));
                } else if (isFramed && !isMatSelected) {
                    framed_image_width = Number(currentSize.width) + 2 * Number(currentSize.frameThickness);
                    framed_image_height = Number(currentSize.height) + (2 * Number(currentSize.frameThickness));
                } else if (isFramed && isMatSelected) {
                    framed_image_width = Number(currentSize.width) + (2 * Number(currentSize.firstMatSize) + 2 * Number(currentSize.frameThickness))
                    framed_image_height = Number(currentSize.height) + (2 * Number(currentSize.firstMatSize) + 2 * Number(currentSize.frameThickness));
                } else {
                    framed_image_width = Number(currentSize.width);
                    framed_image_height = Number(currentSize.height);
                }
                if (selectedMatcolor && isMatSelected) {
                    matSummary = selectedMatsize + ' - ' + selectedMatcolor;
                } else {
                    matSummary = selectedMatsize;
                }
                var framed_image_size = 'Finished Size : ' + framed_image_width + 'in x ' + framed_image_height + 'in';
                var framesummary = document.querySelector('.larf-frame-summary')
                var lb4bSummary = document.querySelector('.lb4b-summary');
                if (selectedType == 'Print Only') {
                    if (lb4bSummary) lb4bSummary.style.display = 'none';
                } else {
                    if (lb4bSummary) lb4bSummary.style.display = 'block';
                    if (framesummary) {
                        var summary = "<li style='text-decoration:underline; font-weight:600'>Product Summary</li>"
                        if (selectedType == 'Framed') {
                            summary = summary + '<li>Product Type : Giclée Print</li><li>Frame : ' + selectedFrameStyle + '</li><li>Frame Width : 1 in</li><li>Frame Height : 1 in</li><li>Mat : ' + matSummary + '</li><li>Glass : TruVue Acrylic Clear</li><li>Print Size : ' + currentSize.selectedValue + '</li><li>' + framed_image_size + '</li>'
                            framesummary.innerHTML = summary
                        } else if (selectedType == 'Infinity Frame') {
                            summary = summary + '<li>Product Type : Fabric Print & Infinity Frame</li><li>Frame : Midnight Black</li><li>Frame Size: 5/8th in</li><li>Mat : No Mat</li><li>Print Size : ' + currentSize.selectedValue + '</li><li>' + framed_image_size + '</li>'
                            framesummary.innerHTML = summary
                        } else if (selectedType == 'Canvas') {
                            summary = summary + '<li>Product Type :  Canvas Print, Gallery Wrap</li><li>Canvas Depth: 1 in</li><li>Mat : No Mat</li><li>Print Size : ' + currentSize.selectedValue + '</li><li>' + framed_image_size + '</li>'
                            framesummary.innerHTML = summary
                        } else if (selectedType == 'Peel and Stick') {
                            summary = summary + '<li>Product Type : Peel-and-stick adhesive vinyl</li><li>Mat : No Mat</li><li>Print Size : ' + currentSize.selectedValue + '</li><li>' + framed_image_size + '</li>'
                            framesummary.innerHTML = summary
                        } else if (selectedType == 'Wood Mount') {
                            summary = summary + '<li>Product Type :  Wood mounted print, UV coated</li><li>Edge Color : ' + woodMountColorName + '</li><li>Edge Depth: 3/8th in</li><li>Mat : No Mat</li><li>Print Size : ' + currentSize.selectedValue + '</li><li>' + framed_image_size + '</li>'
                            framesummary.innerHTML = summary
                        }
                    }
                }
            }

            function parseDimensions(size) {
                if (!size || typeof size !== 'string') {
                    return null;
                }
                const match = size.match(/(\d+(?:\.\d+)?)\s*in\s*x\s*(\d+(?:\.\d+)?)\s*in/i);
                if (!match) return null;
                return {
                    width: parseFloat(match[1]),
                    height: parseFloat(match[2])
                };
            }

            // function updateFramedCanvas(size, event, retryCount = 0) {
            //     const dimensions = parseDimensions(size);
            //     skuDisplay();

            //     if (!dimensions) {
            //         if (retryCount < 20) {
            //             setTimeout(() => {
            //                 updateFramedCanvas(
            //                     currentSize?.selectedValue,
            //                     event,
            //                     retryCount + 1
            //                 );
            //             }, 100);
            //         }
            //         return;
            //     }

            //     const { width, height } = dimensions;
            //     const canFrame = Math.min(width, height) <= 24 && Math.max(width, height) <= 36;
            //     const applyRestriction = () => {
            //         document.querySelectorAll('label.rectangle[data-trans-key="framed"], label.rectangle[data-trans-key="canvas"]').forEach(label => {
            //             label.classList.toggle('rule_strikeOut', !canFrame);
            //         });
            //     };
            //     applyRestriction();
            //     setTimeout(applyRestriction, 50);
            //     setTimeout(applyRestriction, 150);
            //     if (!canFrame && !applyPeel && !printOnlySelect) {
            //         document.querySelector('label.rectangle[data-trans-key="print-only"]')?.click();
            //     }
            // }
            function updateFramedCanvas(size, event, retryCount = 0) {
                const sizeVal = size || document.querySelector('input[action="size"]:checked, input[option_name="Size"]:checked')?.value || (currentSize?.width && currentSize?.height ? `${currentSize.width}in x ${currentSize.height}in` : '');
                const dimensions = parseDimensions(sizeVal);
                if (!dimensions) {
                    if (retryCount < 20) {
                        setTimeout(() => {
                            updateFramedCanvas(size, event, retryCount + 1);
                        }, 100);
                    }
                    return false;
                }
                const { width, height } = dimensions;
                const canFrame = Math.min(width, height) <= 24 && Math.max(width, height) <= 36;
                const applyRestriction = () => {
                    document.querySelectorAll('label.rectangle[data-trans-key="framed"], label.rectangle[data-trans-key="canvas"]').forEach(label => {
                        label.classList.toggle('rule_strikeOut', !canFrame);
                    });
                };
                applyRestriction();
                setTimeout(applyRestriction, 50);
                setTimeout(applyRestriction, 150);
                if (!canFrame && !applyPeel && !printOnlySelect) {
                    const printOnlyBtn = document.querySelector('label.rectangle[data-trans-key="print-only"]');
                    if (printOnlyBtn) {
                        printOnlyBtn.click();
                        return true; // Returns true when switching automatically to Print Only
                    }
                }
                return false;
            }
            let isGalleryView = false;
            setTimeout(() => {
                const gallery = document.getElementById('galleryView-preview');
                const imageCount = document.querySelectorAll('#allImage ul li').length;
                gallery?.classList.toggle('multi-images', imageCount > 1);
                if (imageCount > 1) {
                    document.getElementById('galleryView')?.click();
                    isGalleryView = true;
                }
            }, 100);

            // function getSelectedData(event) {
            //     const el = event?.target;
            //     let action = el?.getAttribute('action');
            //     dataObject = [];
            //     var selectedElements = document.querySelectorAll('all-variant input:checked, all-variant select');
            //     applyPeel = [...selectedElements].some(
            //         el => el.value.trim().toLowerCase() === 'peel and stick'
            //     );
            //     printOnlySelect = [...selectedElements].some(
            //         el => el.value.trim().toLowerCase() === 'print only'
            //     );
            //     const currentSizeString = document.querySelector('input[action="size"]:checked, input[option_name="Size"]:checked')?.value || currentSize?.selectedValue;
            //     updateFramedCanvas(currentSizeString, event);
            //     document.querySelectorAll('[option_name="Size"]').forEach(input => {
            //         input.addEventListener('change', function (event) {
            //             updateFramedCanvas(currentSize.selectedValue, event);
            //         });
            //     });
            //     if (applyPeel) {
            //         document.querySelector('.mainFrameDiv')?.classList.remove('mirrorWrap');
            //         document.querySelector('#sideShow')?.classList.remove('frameSide');
            //         document.querySelector('.mainFrameDiv')?.classList.add('paperPrint');
            //     }
            //     const markupInput = document.querySelector('input[action="markup"]');
            //     if (markupInput) {
            //         markupInput.checked = applyPeel;
            //     }
            //     if (applyPeel) {
            //         applyImageToCanvas(true);
            //     } else {
            //         applyImageToCanvas(false);
            //     }
            //     // applyImageToCanvas(applyPeel);
            //     selectedType = "";
            //     selectedFrameStyle = "";
            //     selectedMatsize = "";
            //     selectedMatcolor = "";
            //     selectedElements.forEach(el => {
            //         const source = el.tagName === 'SELECT' ? el.options[el.selectedIndex] : el;
            //         if (!source) return;
            //         const action = source.getAttribute("action");
            //         const optionName = source.getAttribute("option_name");
            //         if (optionName === "Type") {
            //             selectedType = source.value;
            //         } else if (action === "frame") {
            //             selectedFrameStyle = source.value;
            //         } else if (action === "1st-mat-size") {
            //             selectedMatsize = source.value;
            //         } else if (action === "1st-mat-style") {
            //             selectedMatcolor = source.value;
            //         }
            //         const roomView = document.getElementById('roomView').classList.contains('selected');
					
            //         if (roomView && selectedType) {
            //             const draggableContainer = document.getElementById('draggableContainer');
            //             if (!draggableContainer) {
            //                 console.log('draggableContainer not found');
            //                 return;
            //             }

            //             if (selectedType !== 'Framed') {
            //                 currentSize.frameThickness = 0;
            //                 currentSize.firstMatSize = 0;
            //                 draggableContainer.style.borderWidth = '0px';
            //                 draggableContainer.style.padding = '0px';
            //             } else {
            //                 currentSize.frameThickness = 1;
            //                 const matSize = selectedMatsize === 'No Mat' ? 0 : parseFloat(selectedMatsize) || 0;
            //                 const matThickness = getThicknessinPXonRoom(matSize);
            //                 const frameThickness = getThicknessinPXonRoom(currentSize.frameThickness);
            //                 draggableContainer.style.borderWidth = `${frameThickness}px`;
            //                 draggableContainer.style.padding = `${matThickness}px`;
            //             }
            //         }
            //         const optionValueId = source.getAttribute('data-option-value-id');
            //         if (!optionValueId) return;
            //         // if (action === 'markup') return;
            //         if (selectedType !== 'Framed' && ['frame', '1st-mat-size', '1st-mat-style'].includes(action)) {
            //             return;
            //         }
            //         pricingData
            //             .filter(item => item.option_value_id === optionValueId)
            //             .forEach(item => {
            //                 const matchedRules = item.pricing_v2.filter(priceRule => {
            //                     if (!priceRule.price_type?.includes('exact-size')) {
            //                         return true;
            //                     }
            //                     const currentWidth = Number(currentSize.width);
            //                     const currentHeight = Number(currentSize.height);

            //                     const ruleWidth = Number(priceRule.width);
            //                     const ruleLength = Number(priceRule.length);
            //                     return (
            //                         (currentWidth === ruleWidth && currentHeight === ruleLength) ||
            //                         (currentWidth === ruleLength && currentHeight === ruleWidth)
            //                     );
            //                 });
            //             const isRangePricing = matchedRules.some(rule => rule.price_type?.includes('range'));
            //             if (isRangePricing) {
            //                 const pricing = getPredefinedPrice(matchedRules, matchedRules[0], item.overall_size);
            //                 dataObject.push({
            //                     id: optionValueId,
            //                     overall_size: item.overall_size,
            //                     include_in_frame_size: item.include_in_frame_size,
            //                     price_type: matchedRules[0].price_type,
            //                     unit: matchedRules[0].unit,
            //                     length: '',
            //                     width: '',
            //                     range: pricing.range,
            //                     calculation_unit: matchedRules[0].calculation_unit,
            //                     ...pricing
            //                 });
            //             } else {
            //                 matchedRules.forEach(priceRule => {
            //                     const pricing =
            //                         priceRule.price_type.includes("predefined")
            //                             ? getPredefinedPrice(item.pricing_v2, priceRule, item.overall_size)
            //                             : {
            //                                 price: Number(priceRule.price || 0),
            //                                 calculation_type: priceRule.calculation_type,
            //                             };
            //                     dataObject.push({
            //                         id: optionValueId,
            //                         overall_size: item.overall_size,
            //                         include_in_frame_size: item.include_in_frame_size,
            //                         price_type: priceRule.price_type,
            //                         unit: priceRule.unit,
            //                         length: priceRule.length,
            //                         width: priceRule.width,
            //                         range: priceRule.range,
            //                         calculation_unit: priceRule.calculation_unit,
            //                         ...pricing
            //                     });
            //                 });
            //             }
            //         });
            //     })
            //     pricingCalculation(dataObject);
            //     hispicFrameSummary()
            //     skuDisplay()
            //     addToCart()
            // }
            function getSelectedData(event) {
                const el = event?.target;
                let action = el?.getAttribute('action');
                dataObject = [];
                var selectedElements = document.querySelectorAll('all-variant input:checked, all-variant select');
                applyPeel = [...selectedElements].some(
                    el => el.value.trim().toLowerCase() === 'peel and stick'
                );
                printOnlySelect = [...selectedElements].some(
                    el => el.value.trim().toLowerCase() === 'print only'
                );
                const currentSizeString = document.querySelector('input[action="size"]:checked, input[option_name="Size"]:checked')?.value || currentSize?.selectedValue;
                const redirected = updateFramedCanvas(currentSizeString, event);
                if (redirected) return;
                if (applyPeel) {
                    document.querySelector('.mainFrameDiv')?.classList.remove('mirrorWrap');
                    document.querySelector('#sideShow')?.classList.remove('frameSide');
                    document.querySelector('.mainFrameDiv')?.classList.add('paperPrint');
                }
                const markupInput = document.querySelector('input[action="markup"]');
                if (markupInput) {
                    markupInput.checked = applyPeel;
                }
                if (applyPeel) {
                    applyImageToCanvas(true);
                } else {
                    applyImageToCanvas(false);
                }
                selectedType = "";
                selectedFrameStyle = "";
                selectedMatsize = "";
                selectedMatcolor = "";
                selectedElements.forEach(el => {
                    const source = el.tagName === 'SELECT' ? el.options[el.selectedIndex] : el;
                    if (!source) return;
                    const action = source.getAttribute("action");
                    const optionName = source.getAttribute("option_name");
                    if (optionName === "Type") {
                        selectedType = source.value;
                    } else if (action === "frame") {
                        selectedFrameStyle = source.value;
                    } else if (action === "1st-mat-size") {
                        selectedMatsize = source.value;
                    } else if (action === "1st-mat-style") {
                        selectedMatcolor = source.value;
                    }
                    const roomView = document.getElementById('roomView')?.classList.contains('selected');
                    if (roomView && selectedType) {
                        const draggableContainer = document.getElementById('draggableContainer');
                        if (!draggableContainer) {
                            console.log('draggableContainer not found');
                            return;
                        }
                        if (selectedType !== 'Framed') {
                            currentSize.frameThickness = 0;
                            currentSize.firstMatSize = 0;
                            draggableContainer.style.borderWidth = '0px';
                            draggableContainer.style.padding = '0px';
                        } else {
                            currentSize.frameThickness = 1;
                            const matSize = selectedMatsize === 'No Mat' ? 0 : parseFloat(selectedMatsize) || 0;
                            const matThickness = getThicknessinPXonRoom(matSize);
                            const frameThickness = getThicknessinPXonRoom(currentSize.frameThickness);
                            draggableContainer.style.borderWidth = `${frameThickness}px`;
                            draggableContainer.style.padding = `${matThickness}px`;
                        }
                    }
                    const optionValueId = source.getAttribute('data-option-value-id');
                    if (!optionValueId) return;

                    if (selectedType !== 'Framed' && ['frame', '1st-mat-size', '1st-mat-style'].includes(action)) {
                        return;
                    }
                    pricingData
                        .filter(item => item.option_value_id === optionValueId)
                        .forEach(item => {
                            const matchedRules = item.pricing_v2.filter(priceRule => {
                                if (!priceRule.price_type?.includes('exact-size')) {
                                    return true;
                                }
                                const currentWidth = Number(currentSize.width);
                                const currentHeight = Number(currentSize.height);

                                const ruleWidth = Number(priceRule.width);
                                const ruleLength = Number(priceRule.length);
                                return (
                                    (currentWidth === ruleWidth && currentHeight === ruleLength) ||
                                    (currentWidth === ruleLength && currentHeight === ruleWidth)
                                );
                            });

                            const isRangePricing = matchedRules.some(rule => rule.price_type?.includes('range'));
                            if (isRangePricing) {
                                const pricing = getPredefinedPrice(matchedRules, matchedRules[0], item.overall_size);
                                dataObject.push({
                                    id: optionValueId,
                                    overall_size: item.overall_size,
                                    include_in_frame_size: item.include_in_frame_size,
                                    price_type: matchedRules[0].price_type,
                                    unit: matchedRules[0].unit,
                                    length: '',
                                    width: '',
                                    range: pricing.range,
                                    calculation_unit: matchedRules[0].calculation_unit,
                                    ...pricing
                                });
                            } else {
                                matchedRules.forEach(priceRule => {
                                    const pricing =
                                        priceRule.price_type.includes("predefined")
                                            ? getPredefinedPrice(item.pricing_v2, priceRule, item.overall_size)
                                            : {
                                                price: Number(priceRule.price || 0),
                                                calculation_type: priceRule.calculation_type,
                                            };
                                    dataObject.push({
                                        id: optionValueId,
                                        overall_size: item.overall_size,
                                        include_in_frame_size: item.include_in_frame_size,
                                        price_type: priceRule.price_type,
                                        unit: priceRule.unit,
                                        length: priceRule.length,
                                        width: priceRule.width,
                                        range: priceRule.range,
                                        calculation_unit: priceRule.calculation_unit,
                                        ...pricing
                                    });
                                });
                            }
                        });
                });
                console.log('data object', dataObject)
                pricingCalculation(dataObject);
                hispicFrameSummary();
                skuDisplay();
                addToCart();
            }
            const getCheckedValue = selector => parseFloat(document.querySelector(selector)?.value) || 0;
                let finalPrice = 0;

            function pricingCalculation(selectedData = []) {
                const discount = getCheckedValue('[action="discount"]:checked');
                const markup = getCheckedValue('[action="markup"]:checked');
                const margin = getCheckedValue('[action="margin"]:checked');
                const basePriceText = document.getElementById('larf-display-price')?.innerText || '';
                variantId = document.querySelector('.product-variant-id')?.value;
                const variant = product_variants.find(v => v.id == variantId);
               
                    finalPrice = selectedData.reduce((total, item) => {
                        const { price, calculation_type, price_type, length: ruleLength, width: ruleWidth, unit } = item;
                        if (!price) return total;

                        const { width: currentWidth, height: currentHeight} = getEffectiveSize(item.overall_size);
                        const type = calculation_type || 'fixed-price';
                        let value = 0;

                        const exactLinearLW = Number(ruleLength || 0) + Number(ruleWidth || 0);
                        const exactLinearMax = Math.max(Number(ruleLength || 0), Number(ruleWidth || 0));
                        const exactPerimeter = 2 * (Number(ruleLength || 0) + Number(ruleWidth || 0));
                        let exactSurfaceArea = Number(ruleLength || 0) * Number(ruleWidth || 0);

                        const currentLinearLW = currentWidth + currentHeight;
                        const currentLinearMax = Math.max(currentWidth, currentHeight);
                        const currentPerimeter = 2 * (currentWidth + currentHeight);
                        let currentSurfaceArea = currentWidth * currentHeight;

                        const surfaceFactor =
                            unit === 'in' ? 144 :
                                unit === 'cm' ? 10000 :
                                    unit === 'mm' ? 1000000 :
                                        1;

                        exactSurfaceArea /= surfaceFactor;
                        currentSurfaceArea /= surfaceFactor;

                        const isExactSize = price_type?.includes('exact-size');
                        switch (true) {
                            case type === 'linear_max': value = price * (isExactSize ? exactLinearMax : currentLinearMax);
                                break;

                            case type?.includes('linear'): value = price * (isExactSize ? exactLinearLW : currentLinearLW);
                                break;

                            case type === 'perimeter': value = price * (isExactSize ? exactPerimeter : currentPerimeter);
                                break;

                            case type?.includes('surface'): value = price * (isExactSize ? exactSurfaceArea : currentSurfaceArea);
                                break;

                            case type === 'fixed-price':
                            default:
                                value = price;
                                break;
                        }
                        return total + value;
                    }, 0);
                    
                    // if (variant) finalPrice += variant.price / 100;
                    if (selectedData.length === 0 && variant) {
                        finalPrice += variant.price / 100;
                    }
                    // Apply markup & margin
                    if (markup) finalPrice *= 1 + markup / 100;
                    if (margin) finalPrice /= 1 - margin / 100;
                // }
                // Discount UI
                if (discount) {
                    const discountedPrice = finalPrice * (1 - discount / 100);
                    document.querySelector('.livevue-display-price').style.textDecoration = 'line-through';
                    document.querySelector('.livevue-discount-price').style.display = 'inline-block';
                    document.querySelector('.livevue-sale-banner').style.display = 'inline-block';
                    document.querySelector('.livevue-discount-price').innerText = moneyWithCurrency(basePriceText, discountedPrice);
                }
                larfPrice = finalPrice;
                // Final price display
                document.querySelector('.livevue-display-price').innerText = moneyWithCurrency(basePriceText, finalPrice);
                // Add to cart toggle
                document.querySelector('[name="add"]').disabled = finalPrice === 0;
            }

            async function checkOrderJson(optionName) {
                const targetPrice = Number(larfPrice).toFixed(2);
                for (const product of orderJson || []) {
                    const variant = product.variants?.find(v => v.variant_title === optionName);
                    if (variant) {
                        return {
                            variantId: variant.variant_id,
                            isVariant: true,
                            priceNeedsUpdate: variant.variant_price != targetPrice,
                            order_productId: product.order_product_id
                        };
                    }
                }
                return { variantId: undefined, isVariant: false, priceNeedsUpdate: false };
            }
            async function getOrderProperties1() {
                const jsonObject = {}
                const selectedVelues = document.querySelectorAll(
                ':is(livearf-variant-selects, variant-selects) fieldset.rule_visible:not([data-is-not-cart-property="true"]) input:checked, ' +
                ':is(livearf-variant-selects, variant-selects) fieldset:not(.hideBlock):not([data-is-not-cart-property="true"]) input:checked, ' +
                ':is(livearf-variant-selects, variant-selects) fieldset:not(.rule_hidden):not([data-is-not-cart-property="true"]) input[type="number"]'
                );
                for (const each of selectedVelues) {
                    if (each.getAttribute('action') != 'discount' || each.getAttribute('action') != 'markup' || each.getAttribute('action') != 'margin') {
                        const optionName = each?.parentNode?.querySelector('legend')?.innerText || each.labels[0].innerText;
                        const optionValue = each?.value || each?.labels[0]?.querySelector('small')?.innerText;
                        jsonObject[optionName] = optionValue;
                    }
                }
                if (croppedData.originalImage) {
                    jsonObject["Original Image"] = croppedData.originalImage;
                    jsonObject["Cropped Image"] = getCroppedImage();
                }
                return jsonObject;
            }
            document.querySelectorAll('all-variant input, all-variant select').forEach(el => {
                el.addEventListener('change', getSelectedData);
                el.addEventListener('change', () => {
                    if (isGalleryView) {
                        const galleryView = document.getElementById('galleryView');
                        if (galleryView?.classList.contains('selected')) {
                            document.getElementById('frameView')?.click();
                            isGalleryView = false
                        }
                    } // change function
                })
            })
            setTimeout(() => {
                getSelectedData();// onload
            }, 500); 

		var frameThickness;
		var elements = document.querySelectorAll('#enlargeIcon, #frameViewCanvas');
		if (elements) {
			elements.forEach(function (element) {
				element.addEventListener('click', function () {
					var frameCheckedElement = document.querySelector('input[action="frame"]:checked');
					frameThickness = currentSize.frameThickness
					var selectedBGImage = frameCheckedElement ? frameCheckedElement.getAttribute('data-frame-url') : undefined;
					var src = mainImage.src;
					var dividedNumber = Number(currentSize.width) + (Number(frameThickness) * 2);
					var dividedWidth = offsetwidth / dividedNumber
					var frameViewBorderWidth = dividedWidth * frameThickness;
					var frameViewMatWidth;
                    if (selectedMatsize == '2.0 in') {
                        frameViewMatWidth = (2 * Number(frameViewBorderWidth)).toFixed(2);
                    } else if (selectedMatsize == '3.0 in') {
                        frameViewMatWidth = (3 * Number(frameViewBorderWidth)).toFixed(2);
                    } else {
                        frameViewMatWidth = 0;
                    }
					if (selectedType !== 'Framed') {
						frameViewBorderWidth = frameViewMatWidth = 0;
					}

					// needs to change based on type options if needed
					if (selectedType === 'Infinity Frame') {
						enlarge.innerHTML = '<img style="border-width:2px !important;border-style: solid !important; border-color:black !important; background-size:cover; background-repeat:no-repeat;background-position:center;" src="' + src + '">'
					} else if (selectedType === 'Wood Mount') {
						enlarge.innerHTML = '<img style="border: 3px outset ' + woodMountColor + '; padding: 0px !important; background-size:cover; background-repeat:no-repeat;background-position:center;" src="' + src + '">'
					} else {
						enlarge.innerHTML = '<img style="border-width:' + frameViewBorderWidth + 'px !important;border-style: solid !important; border-color:white !important; border-image: url(' + selectedBGImage + ') !important; border-image-slice: ' + 50 + ' !important; padding: ' + frameViewMatWidth + 'px !important; background-color: ' + selectedMatcolor + ' !important; background-size:cover; background-repeat:no-repeat;background-position:center;" src="' + src + '">'
					}
					document.getElementById('enlarge').style.display = 'block';
					document.getElementById('enlarge').style.cssText = "background: RGBA(109,109,109,.84); background-size: contain; width: 100%; height: 100%; position: fixed; z-index: 10000; top: 0; right: 0; left: 0; bottom: 0; cursor: zoom-out; display: flex; text-align: center; justify-content: center; padding: 15px;";
					if (window.matchMedia("(max-width: 600px)").matches) {
						enlarge.style.alignItems = 'center';
					} else {
						enlarge.style.alignItems = '';
					}
					document.getElementById('enlarge').addEventListener('click', function () {
						this.style.display = 'none';
					});
				});
			});
		}

		const mediaGalleryImage = document.getElementById('mediaGalleryImage');
		if (mediaGalleryImage) {
			mediaGalleryImage.addEventListener('click', function () {
				let enlarge = document.querySelector('#enlarge');
				if (enlarge) {
					enlarge.innerHTML = '<img style="background-size:cover; background-repeat:no-repeat;background-position:center;" src="' + this.src + '">'
				}
				enlarge.style.display = 'block';
				enlarge.style.cssText = "background: RGBA(109,109,109,.84); background-size: contain; width: 100%; height: 100%; position: fixed; z-index: 10000; top: 0; right: 0; left: 0; bottom: 0; cursor: zoom-out; display: flex; text-align: center; justify-content: center; padding: 15px;";
				if (window.matchMedia("(max-width: 600px)").matches) {
					enlarge.style.alignItems = 'center';
				} else {
					enlarge.style.alignItems = '';
				}
				enlarge.addEventListener('click', function () {
					this.style.display = 'none';
				});
			});
		}

            document.querySelector('#galleryView')?.addEventListener('click', function () {
                document.querySelector('label.rectangle[data-trans-key="print-only"]')?.click();
                isGalleryView = true;
            });
            document.querySelectorAll('#roomView, #frameView, #galleryView').forEach(element => {
                element.addEventListener('click', () => {
                    setTimeout(() => {
                        const selectedValue = selectedType;
                        const applyPeel = selectedValue.trim().toLowerCase() === 'peel and stick';
                        applyImageToCanvas(applyPeel);

						const roomView = document.getElementById('roomView').classList.contains('selected');
						if (roomView && selectedType) {
							const draggableContainer = document.getElementById('draggableContainer');
							if (!draggableContainer) {
								console.log('draggableContainer not found');
								return;
							}

							if (selectedType !== 'Framed') {
								currentSize.frameThickness = 0;
								currentSize.firstMatSize = 0;
								draggableContainer.style.borderWidth = '0px';
								draggableContainer.style.padding = '0px';
							} else {
								currentSize.frameThickness = 1;
								const matSize = selectedMatsize === 'No Mat' ? 0 : parseFloat(selectedMatsize) || 0;
								const matThickness = getThicknessinPXonRoom(matSize);
								const frameThickness = getThicknessinPXonRoom(currentSize.frameThickness);
								draggableContainer.style.borderWidth = `${frameThickness}px`;
								draggableContainer.style.padding = `${matThickness}px`;
							}
						}
                    }, 120);
                });
            });
            // document.getElementById('previewIcons')?.addEventListener('click', (event) => {
            //     const preview = event.target.closest('#previewIcons li.animate');
            //     if (!preview) return;
            //     setTimeout(() => {
            //         applyImageToCanvas(applyPeel);
            //     }, 120);
            // });

            if (frameSelling == 'preview-only') {
                let lb4bNote = document.createElement('div');
                lb4bNote.className = 'preview-only';
                lb4bNote.innerHTML = `<span class="lb4-note" style="color:red"><font style="vertical-align: inherit;"><font style="vertical-align: inherit;">(Note: Frames are available for preview purposes only.</font></font><font style="vertical-align: inherit;"><font style="vertical-align: inherit;">)</font></font></span>`;
                let addToCartButton = document.querySelector('[name="add"]');
                addToCartButton.parentNode.insertBefore(lb4bNote, addToCartButton);
            }
            async function shopifyFlow() {
                let properties = {}
                properties["Type"] = "PRINT ONLY"
                properties["SKU"] = generateSku();
                var cartData = {
                    "id": document.querySelector('.product-variant-id').value,
                    "properties": properties,
                    "quantity": document.querySelector('.quantity__input').value
                };
                let cartResponse = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(cartData)
                });
                if (!cartResponse.ok) {
                    throw new Error('Failed to add item to cart');
                }
                await cartResponse.json();
                window.location.href = '/cart';
            }
            if (frameSelling == 'for-sale') {
                document.querySelector('[name=add]').addEventListener('click', async function (e) {
                    e.preventDefault();
                    const markup = document.querySelector('input[action="markup"]').dataset.optionValueId;
                    if(applyPeel){
                        dataObject.push({
                            id: markup,
                        });
                    }
                    if (printOnlySelect) {
                        shopifyFlow()
                    } else {
                        document.getElementById('frameView').click();
                        document.getElementById('larfloader').style.display = 'flex';
                        let index = 1;
                        let interval = (Number(livevue_settings?.settings?.addtoCart?.settings?.loader_message_interval) ?? 2) * 1000;
                        setInterval(() => {
                            loaderText.textContent = cartMessages[index]?.value;
                            index = (index + 1) % cartMessages.length;
                        }, interval);
                        allProperties = await getOrderProperties1();
                        cloneElementForScreenShot();
                    }
                });
            }
            //clone element function for screenShot.
            async function cloneElementForScreenShot() {
                let existingClonedDiv = document.getElementById('newPreviewArea');
                if (existingClonedDiv) existingClonedDiv.remove();
                let originalDiv = document.querySelector('.main-previewArea');
                let clonedDiv = originalDiv.cloneNode(true);
                clonedDiv.id = 'newPreviewArea';
                clonedDiv.classList.add('new' + originalDiv.classList[1]);
                let mainFrame = document.querySelector('.mainimageDiv');
                let newMainFrameDiv = clonedDiv.querySelector('.mainFrameDiv');
                let newMainImageDiv = clonedDiv.querySelector('.mainimageDiv');
                newMainFrameDiv.classList.add('new' + newMainFrameDiv.classList[0]);
                newMainFrameDiv.style.width = `${mainFrame.offsetWidth}px`;
                newMainImageDiv.classList.add('new' + newMainImageDiv.classList[0]);
                let imageElement = document.createElement('img');
                imageElement.className = "newimage-magnify-lightbox";
                imageElement.style.width = document.querySelector('#frameViewCanvas').offsetWidth + 'px';
                imageElement.style.height = document.querySelector('#frameViewCanvas').offsetHeight + 'px';
                imageElement.src =  mainImage.src
                newMainImageDiv.appendChild(imageElement);
                originalDiv.parentNode.appendChild(clonedDiv);
                clonedDiv.style.display = 'none';
                let canvasElement = clonedDiv.querySelector('.newmainFrameDiv canvas');
                if (canvasElement) canvasElement.remove();
                orderProperties();
            }
            async function orderProperties() {
                let variant_Data = {};
                let result;
                let checkOrder;
                let optionName = Object.entries(allProperties).filter(([key, val]) => key !== "Width" && key !== "Height" && key !== "_Markup Component" && typeof val === "string" && !val.includes("https")).map(([key, val]) => val).join("/");
                checkOrder = await checkOrderJson(optionName);
                orderImage = mainImage.src;
                allProperties["_source"] = document.querySelector('[property="og:url"]').getAttribute('content');
                allProperties["SKU"] = generateSku();
                localStorage.setItem("livevue_orderImage", orderImage);
                let frameStyles = document.querySelector(".mainFrameDiv")?.getAttribute("style") || "";
                localStorage.setItem("livevue_frameStyles", frameStyles);
                let matStyles = document.querySelector(".mainimageDiv")?.getAttribute("style") || "";
                localStorage.setItem("livevue_matStyles", matStyles);
                variant_Data.variant_data = dataObject;      
                variant_Data.option_name = "Combination";
                variant_Data.option_value = optionName;
                if(applyPeel){
                    variant_Data.variant_id = variantId;
                }
                if (selectedType == 'Framed') {
                    localStorage.setItem("isFramed", "true");
                }
                variant_Data.width = currentSize.width;
                variant_Data.height = currentSize.height;
                variant_Data.shop_domain = Shopify.shop;
                variant_Data.unit = currentSize.unit;
                variant_Data.app_name = 'larfsh';
                variant_Data.plt_prod_id = meta.product.id;
                variant_Data.plt_prod_name = document.querySelector('[property="og:title"]').content;
                variant_Data.product_sku = generateSku(),
                variant_Data.image_upload = livevueImgUpload;
                variant_Data.html_element = document.querySelector('.newmainFrameDiv')?.outerHTML;
                if(!livevueImgUpload && checkOrder?.isVariant){
                    const url = `/variants/${checkOrder.variantId}.json`;
                    let response = await fetch(url);
                    if (!response.ok) {
                        variantRemoved = true;
                    }
                }

                if (!variantRemoved && !livevueImgUpload && checkOrder.isVariant && !checkOrder.priceNeedsUpdate) {
                    console.log('priceNO Needs to Update', variant_Data)
                    result = { variantid: checkOrder.variantId }
                } else {
                    console.log('priceNeedsUpdate', variant_Data)
                    if (!variantRemoved && !livevueImgUpload && checkOrder.priceNeedsUpdate) {
                        variant_Data.variant_update_data = {}
                        variant_Data.variant_update_data.variant_id = checkOrder.variantId;
                        variant_Data.variant_update_data.product_id = checkOrder.order_productId;
                    }
                    let response = await fetch(`/apps/ShopAuth/cartPagePricingV5`, {
                        method: 'POST',
                        body: JSON.stringify(variant_Data)
                    });
                    if (!response.ok) {
                        throw new Error('Failed to fetch cart page pricing');
                    }
                    result = await response.json();
                    if (!livevueImgUpload && !checkOrder.variantId) {
                        localStorage.setItem('livevue_variantId', result.variantid)
                    }
                }

                let cartData = {
                    "id": result.variantid,
                    "properties": allProperties,
                    "quantity": document.querySelector('#livevue-Template [name="quantity"]').value
                };
                document.getElementById('larfloader').style.display = 'none';
                document.getElementById('newPreviewArea')?.remove();
                orderProcess(cartData, 'cart')
            }
        }
    }
    const checkInterval = setInterval(() => {
        if(currentSize.width){
            getSelectedData();
            updateFramedCanvas(currentSize.selectedValue);
            clearInterval(checkInterval);
        }
        else{
            document.querySelector("[action='size']:checked").click()
        }
    }, 300);
} else if (pathSh == 'cart') {
    function updateCartLinks() {
        const image = localStorage.getItem('livevue_orderImage');
        const style = localStorage.getItem('livevue_frameStyles');
        const mat = localStorage.getItem('livevue_matStyles');

        if (image) {
            const cartItem = document.getElementById('CartItem-1');
            const mediaCell = cartItem?.querySelector('.cart-item__media');

            if (mediaCell) {
                let imageContainer = mediaCell.querySelector('.cart-item__image-container');

                // Create image container if it doesn't exist
                if (!imageContainer) {
                    imageContainer = document.createElement('div');
                    imageContainer.className = 'cart-item__image-container gradient global-media-settings';

                    const img = document.createElement('img');
                    img.className = 'cart-item__image';
                    img.alt = 'New Product Image';
                    img.loading = 'lazy';
                    img.onload = function () {
                        console.log('Image size:', img.naturalWidth, img.naturalHeight);
                    };
                    img.src = image;
                    imageContainer.appendChild(img);
                    mediaCell.appendChild(imageContainer);
                }

                const img = imageContainer.querySelector('img');
                if (img) {
                    img.src = image;
                    img.alt = 'New Product Image';
                    if (style) {
                        imageContainer.style.cssText = style;
                        const computedStyle = window.getComputedStyle(imageContainer);
                        imageContainer.style.borderWidth = `${parseFloat(computedStyle.borderWidth) / 4}px`;
                        imageContainer.style.padding = `${parseFloat(computedStyle.padding) / 4}px`;
                        imageContainer.style.borderColor = '';
                    }

                    if (mat) {
                        img.style.cssText = mat;
                        const computedStyle = window.getComputedStyle(img);
                        img.style.padding = `${parseFloat(computedStyle.padding) / 4}px`;
                    }
                }
            }
        }

        const cartPage_data = document.getElementsByClassName('cart-item');
        fetch('/cart.json')
            .then(response => response.json())
            .then(data => {
                data.items.forEach((eachitem, i) => {
                    if ('_source' in eachitem.properties && cartPage_data[i]) {
                        const link = cartPage_data[i].children[1]?.children[0];
                        if (link) {
                            link.href = eachitem.properties['_source'];
                        }
                    }
                });
            });
    }
    if(!printOnlySelect){
        updateCartLinks();
    }
    if (localStorage.getItem("isFramed")) {
        setTimeout(() => {
            localStorage.clear();
        }, 1000);
    }
    let cartContainer = document.querySelector('.cart__items');
    if (cartContainer) {
        const observer = new MutationObserver(updateCartLinks);
        observer.observe(cartContainer, { childList: true, subtree: true });
    }
    let variantId = localStorage.getItem('livevue_variantId');
    if (variantId) {
        document.body.style.filter = 'blur(5px)';
        let intervalId = setInterval(async () => {
            try {
                const response = await fetch('/cart.js');
                if (!response.ok) throw new Error('Failed to fetch cart data');

                const cart = await response.json();
                const item = cart.items.find(i => i.variant_id == parseInt(variantId));

                if (item && parseFloat(item.price) > 0) {
                    clearInterval(intervalId);
                    localStorage.removeItem('livevue_variantId');
                    document.body.style.filter = 'none';
                    const priceEl = document.querySelector('.cart-item__totals').children[1].children[0];
                    const priceText = priceEl.innerText.replace(/\s+/g, '').trim();
                    if (priceText === '$0.00') {
                        location.reload();
                    }
                }
            } catch (error) {
                console.error('Error checking cart:', error);
            }
        }, 700);
    }
}
